import React from "react";
import { NavLink } from "react-router-dom";
import { CONTACT } from "../config/site";
import "../styles/page-cta.css";

/**
 * ContactCTA — consistent "talk to Cloudare" banner used across content pages.
 * Teal band, two actions: book a call + contact form.
 */
export default function ContactCTA({
  title = "Talk to the Cloudare team",
  subtitle = "Tell us your ERP and compliance landscape — we'll map the right approach.",
  primaryLabel = "Book a discovery call",
  secondaryLabel = "Contact us",
}) {
  return (
    <section className="contact-cta reveal">
      <div className="contact-cta__inner">
        <h2 className="contact-cta__title">{title}</h2>
        <p className="contact-cta__subtitle">{subtitle}</p>
        <div className="contact-cta__actions">
          <a
            className="contact-cta__btn contact-cta__btn--primary"
            href={CONTACT.calendly}
            target="_blank"
            rel="noopener noreferrer"
          >
            {primaryLabel}
          </a>
          <NavLink
            className="contact-cta__btn contact-cta__btn--ghost"
            to="/contact-us"
          >
            {secondaryLabel}
          </NavLink>
        </div>
      </div>
    </section>
  );
}
